<div class="ai-assistant-editor-container">
  <!-- 標題列 -->
  <div class="header-section">
    <h2 class="page-title">{{ 'assistant.editor.title' | translate }}</h2>
  </div>

  <!-- 助手選擇區塊 -->
  <div class="assistant-selector-section" *ngIf="!isLoadingAssistants && assistantOptions.length > 0">
    <div class="form-group">
      <label class="form-label">{{ 'assistant.editor.select_assistant' | translate }}</label>
      <select
        class="form-select"
        [value]="assistantNo"
        (change)="onAssistantChange($any($event.target).value)"
        [disabled]="isLoadingAssistants">
        <option value="">{{ 'assistant.editor.please_select_assistant' | translate }}</option>
        <option
          *ngFor="let assistant of assistantOptions"
          [value]="assistant.assistantNo">
          {{ assistant.title }}
        </option>
      </select>
      <div *ngIf="isLoadingAssistants" class="loading-text">
        <i class="fas fa-spinner fa-spin"></i> {{ 'assistant.editor.loading_assistants' | translate }}
      </div>
    </div>
  </div>

  <!-- 載入狀態 -->
  <div *ngIf="isLoading" class="loading-overlay">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">載入中...</span>
    </div>
    <p class="loading-text">{{ 'assistant.editor.loading' | translate }}</p>
  </div>

  <!-- 錯誤訊息 -->
  <div *ngIf="errorMessage" class="alert alert-danger" role="alert">
    <i class="fas fa-exclamation-triangle"></i> {{ errorMessage }}
  </div>

  <!-- 成功訊息 -->
  <div *ngIf="successMessage" class="alert alert-success" role="alert">
    <i class="fas fa-check-circle"></i> {{ successMessage }}
  </div>

  <!-- 提示訊息：未選擇助手 -->
  <div *ngIf="!assistantNo && !isLoadingAssistants && assistantOptions.length > 0" class="alert alert-info" role="alert">
    <i class="fas fa-info-circle"></i> {{ 'assistant.editor.please_select_first' | translate }}
  </div>

  <!-- 提示訊息：載入助手清單中 -->
  <div *ngIf="isLoadingAssistants" class="alert alert-secondary" role="alert">
    <i class="fas fa-spinner fa-spin"></i> {{ 'assistant.editor.loading_list' | translate }}
  </div>

  <!-- 提示訊息：沒有可用的助手 -->
  <div *ngIf="!assistantNo && !isLoadingAssistants && assistantOptions.length === 0" class="alert alert-warning" role="alert">
    <i class="fas fa-exclamation-triangle"></i> {{ 'assistant.editor.no_assistants_available' | translate }}
  </div>

  <!-- 編輯表單 -->
  <form [formGroup]="assistantForm" (ngSubmit)="onSubmit()" class="assistant-form" *ngIf="assistantNo && assistantNo.trim() !== ''">
    <!-- 基本資訊區塊 -->
    <div class="form-section">
      <h3 class="section-title">{{ 'assistant.editor.basic_info' | translate }}</h3>

      <!-- 助手編號 (唯讀) -->
      <div class="form-group">
        <label class="form-label">{{ 'assistant.editor.assistant_number' | translate }}</label>
        <input type="text" class="form-control" [value]="assistantNo" readonly>
      </div>

      <!-- 標題 -->
      <div class="form-group">
        <label class="form-label">{{ 'assistant.editor.title_label' | translate }}</label>
        <input
          type="text"
          class="form-control"
          formControlName="title"
          [placeholder]="'assistant.editor.title_placeholder' | translate"
          [class.is-invalid]="assistantForm.get('title')?.errors && assistantForm.get('title')?.touched">
        <div class="invalid-feedback">
          {{ getFieldError('title') }}
        </div>
      </div>

      <!-- 內容 -->
      <div class="form-group">
        <label class="form-label">{{ 'assistant.editor.content_label' | translate }}</label>
        <textarea
          class="form-control"
          formControlName="content"
          rows="5"
          [placeholder]="'assistant.editor.content_placeholder' | translate"
          [class.is-invalid]="assistantForm.get('content')?.errors && assistantForm.get('content')?.touched">
        </textarea>
        <div class="invalid-feedback">
          {{ getFieldError('content') }}
        </div>
      </div>

      <!-- 備註 -->
      <div class="form-group">
        <label class="form-label">{{ 'assistant.editor.memo_label' | translate }}</label>
        <textarea
          class="form-control"
          formControlName="memo"
          rows="3"
          [placeholder]="'assistant.editor.memo_placeholder' | translate"
          [class.is-invalid]="assistantForm.get('memo')?.errors && assistantForm.get('memo')?.touched">
        </textarea>
        <div class="invalid-feedback">
          {{ getFieldError('memo') }}
        </div>
      </div>
    </div>

    <!-- 圖片設定區塊 -->
    <div class="form-section">
      <h3 class="section-title">{{ 'assistant.editor.image_settings' | translate }}</h3>

      <!-- 圖片預覽 -->
      <div class="image-preview-section" *ngIf="imagePreviewUrl">
        <div class="image-preview-container">
          <img [src]="imagePreviewUrl" [alt]="'assistant.editor.assistant_image' | translate" class="image-preview">
          <button type="button" class="btn btn-danger btn-sm remove-image-btn" (click)="removeImage()">
            <i class="fas fa-trash"></i> {{ 'assistant.editor.remove' | translate }}
          </button>
        </div>
      </div>

      <!-- 圖片網址 -->
      <div class="form-group">
        <label class="form-label">{{ 'assistant.editor.image_url' | translate }}</label>
        <input
          type="url"
          class="form-control"
          formControlName="imageurl"
          placeholder=""
          [class.is-invalid]="assistantForm.get('imageurl')?.errors && assistantForm.get('imageurl')?.touched">
        <div class="invalid-feedback">
          {{ getFieldError('imageurl') }}
        </div>
      </div>





      <!-- 圖片上傳區域 -->
      <div class="upload-section">
        <label class="form-label">{{ 'assistant.editor.upload_new_image' | translate }}</label>
        <div
          class="upload-area"
          (dragover)="onDragOver($event)"
          (dragleave)="onDragLeave($event)"
          (drop)="onFileDrop($event)">

          <div class="upload-content">
            <i class="fas fa-cloud-upload-alt upload-icon"></i>
            <p class="upload-text">{{ 'assistant.editor.drag_drop_text' | translate }}</p>
            <p class="upload-hint">{{ 'assistant.editor.upload_hint' | translate }}</p>

            <input
              type="file"
              class="file-input"
              accept="image/*"
              (change)="onFileSelected($event)"
              id="fileInput">
            <label for="fileInput" class="btn btn-primary btn-select-file">{{ 'assistant.editor.select_file' | translate }}</label>
          </div>
        </div>

        <!-- 上傳進度 -->
        <div *ngIf="isUploading" class="upload-progress-container">
          <div class="progress">
            <div
              class="progress-bar progress-bar-striped progress-bar-animated"
              [style.width.%]="uploadProgress">
              {{ uploadProgress }}%
            </div>
          </div>
          <p class="upload-status">{{ 'assistant.editor.uploading' | translate }}</p>
        </div>
      </div>


         <!-- 替代顯示設定 -->
      <div class="alternative-display-section" *ngIf="!assistantForm.get('imageurl')?.value">
        <h4 class="subsection-title">
          <i class="fas fa-palette"></i> {{ 'assistant.editor.alternative_display' | translate }}
        </h4>
        <p class="subsection-description">{{ 'assistant.editor.alternative_display_desc' | translate }}</p>

        <!-- 助手文字 -->
        <div class="form-group">
          <label class="form-label">{{ 'assistant.editor.display_text' | translate }}</label>
          <input
            type="text"
            class="form-control"
            formControlName="assistant_text"
            [placeholder]="'assistant.editor.display_text_placeholder' | translate"
            maxlength="50"
            [class.is-invalid]="assistantForm.get('assistant_text')?.errors && assistantForm.get('assistant_text')?.touched">
          <small class="form-text text-muted">{{ 'assistant.editor.display_text_help' | translate }}</small>
          <div class="invalid-feedback">
            {{ getFieldError('assistant_text') }}
          </div>
        </div>

        <!-- 助手顏色設定 -->
        <div class="form-group">
          <label class="form-label">{{ 'assistant.editor.background_color_settings' | translate }}</label>
          <div class="color-input-container">
            <!-- 左側：顏色選擇器和輸入框 -->
            <div class="color-controls">
              <!-- 背景色設定 -->
              <div class="color-field-group">
                <h5 class="color-field-title">{{ 'assistant.editor.background_color' | translate }}</h5>

                <!-- 背景色選擇器 -->
                <div class="input-group-with-label">
                  <small class="input-label">{{ 'assistant.editor.color_picker' | translate }}</small>
                  <input
                    type="color"
                    class="form-control color-picker-compact"
                    formControlName="assistant_bg_color"
                    [class.is-invalid]="assistantForm.get('assistant_bg_color')?.errors && assistantForm.get('assistant_bg_color')?.touched">
                </div>

                <!-- 背景色碼輸入框 -->
                <div class="input-group-with-label">
                  <small class="input-label">{{ 'assistant.editor.color_code_input' | translate }}</small>
                  <input
                    type="text"
                    class="form-control color-code-input"
                    formControlName="assistant_bg_color"
                    placeholder="#f5820d"
                    pattern="^#[0-9A-Fa-f]{6}$"
                    maxlength="7"
                    (input)="onBgColorCodeInput($event)"
                    [class.is-invalid]="assistantForm.get('assistant_bg_color')?.errors && assistantForm.get('assistant_bg_color')?.touched">
                </div>

                <!-- 背景色常用顏色選項 -->
                <div class="input-group-with-label">
                  <small class="input-label">{{ 'assistant.editor.common_colors' | translate }}</small>
                  <div class="preset-colors-compact">
                    <div class="preset-color-buttons">
                      <button
                        type="button"
                        class="preset-color-btn"
                        *ngFor="let color of presetColors"
                        [style.background-color]="color.value"
                        [title]="color.name + ' (' + color.value + ')'"
                        (click)="selectPresetBgColor(color.value)">
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <!-- 文字色設定 -->
              <div class="color-field-group">
                <h5 class="color-field-title">{{ 'assistant.editor.text_color' | translate }}</h5>

                <!-- 文字色選擇器 -->
                <div class="input-group-with-label">
                  <small class="input-label">{{ 'assistant.editor.color_picker' | translate }}</small>
                  <input
                    type="color"
                    class="form-control color-picker-compact"
                    formControlName="assistant_font_color"
                    [class.is-invalid]="assistantForm.get('assistant_font_color')?.errors && assistantForm.get('assistant_font_color')?.touched">
                </div>

                <!-- 文字色碼輸入框 -->
                <div class="input-group-with-label">
                  <small class="input-label">{{ 'assistant.editor.color_code_input' | translate }}</small>
                  <input
                    type="text"
                    class="form-control color-code-input"
                    formControlName="assistant_font_color"
                    placeholder="#ffffff"
                    pattern="^#[0-9A-Fa-f]{6}$"
                    maxlength="7"
                    (input)="onFontColorCodeInput($event)"
                    [class.is-invalid]="assistantForm.get('assistant_font_color')?.errors && assistantForm.get('assistant_font_color')?.touched">
                </div>

                <!-- 文字色常用顏色選項 -->
                <div class="input-group-with-label">
                  <!-- <small class="input-label">常用顏色</small> -->
                  <div class="preset-colors-compact">
                    <div class="preset-color-buttons">
                      <button
                        type="button"
                        class="preset-color-btn"
                        *ngFor="let fontColor of presetFontColors"
                        [style.background-color]="fontColor.value"
                        [title]="fontColor.name + ' (' + fontColor.value + ')'"
                        (click)="selectPresetFontColor(fontColor.value)">
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- 右側：大預覽畫面 -->
            <div class="color-preview-large"
                 [style.background-color]="assistantForm.get('assistant_bg_color')?.value"
                 [style.color]="assistantForm.get('assistant_font_color')?.value">
              <span class="color-text-large" *ngIf="assistantForm.get('assistant_text')?.value">
                {{ assistantForm.get('assistant_text')?.value }}
              </span>
              <span class="color-text-large" *ngIf="!assistantForm.get('assistant_text')?.value">
                AI
              </span>
            </div>
          </div>

          <small class="form-text text-muted">
            {{ 'assistant.editor.color_preview_help' | translate }}
          </small>
          <div class="invalid-feedback">
            {{ getFieldError('assistant_bg_color') || getFieldError('assistant_font_color') }}
          </div>
        </div>
      </div>

    </div>

    <!-- 按鈕區域 -->
    <div class="form-actions">
      <button
        type="submit"
        class="btn btn-primary"
        [disabled]="assistantForm.invalid || isLoading || isUploading">
        <i class="fas fa-save"></i> {{ 'assistant.editor.save_changes' | translate }}
      </button>

      <button
        type="button"
        class="btn btn-secondary"
        (click)="resetForm()"
        [disabled]="isLoading || isUploading">
        <i class="fas fa-undo"></i> {{ 'assistant.editor.reset' | translate }}
      </button>
    </div>
  </form>
</div>
